import { Money } from '../items/ItemList';
import React from 'react';
import { ButtonGroup } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import DeleteInvoice from './containers/DeleteInvoice';
import { INVOICE_TYPE } from './containers/InvoiceList';
import { dateCell } from '../items/ItemList';

function invoiceActions(cell, row) {
    return (
        <ButtonGroup>
            <NavLink to={`/invoices/${row.id}`} className='btn btn-primary'>
                <i className='fa fa-edit'> </i>
            </NavLink>
            <a href={row.url} className='btn btn-primary'>
                <i className={'fa fa-download'}> </i>
            </a>
            <DeleteInvoice invoice={row} />
        </ButtonGroup>
    )
}

export const invoiceListColumns = [
    {
        text: 'Rechnungsnummer',
        dataField: 'invoice_nr',
        align: 'right',
        sort: true
    },
    {
        text: 'Kunde',
        dataField: 'customer.name',
        sort: true,
    },
    {
        text: 'Rechnungsdatum',
        dataField: 'invoice_date',
        sort: true,
        align: 'right',
        formatter: cell => dateCell(cell)
    },
    {
        text: 'Fälligkeitsdatum',
        dataField: 'due_date',
        sort: true,
        align: 'right',
        formatter: cell => dateCell(cell)
    },
    {
        text: 'Status',
        dataField: 'status',
        sort: true,
        formatter: cell => INVOICE_TYPE[cell]
    },
    {
        text: 'Summe',
        dataField: 'after_tax',
        sort: true,
        formatter: cell => Money(cell)
    },
    {
        dataField: 'id',
        text: '',
        isDummyField: true,
        formatter: (cell, row) => invoiceActions(cell, row)
    }
]
    ;
